import isPropValid from '@emotion/is-prop-valid';

export const shouldForwardProp = (propName: string, target: string | React.ComponentType<any>) => {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
};
